import React, { useEffect, useRef, useState } from "react";

const data = [
  {
    name: "David Martinez",
    role: "HR Manager",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    text: "Get smarter and more efficient software with features designed to free you from administrative work.",
  },
  {
    name: "Samantha Payne",
    role: "HR Analyst",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "Easy to use and very reliable. Managing HR tasks is now smooth and time-saving.",
  },
  {
    name: "Albert Flores",
    role: "Payroll Admin",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
    text: "A game changer for streamlining HR processes. Everything feels effortless.",
  },
  {
    name: "Devon Lane",
    role: "Chief Executive",
    image: "https://randomuser.me/api/portraits/men/75.jpg",
    text: "Super intuitive! HR management is now faster and more efficient than ever.",
  },
];

const WallOfLove = () => {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  const items = [...data, ...data]; // infinite

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const card = track.children[0];
    const gap = 24;
    const step = card.offsetWidth + gap;

    track.style.transition = "transform 0.6s ease";
    track.style.transform = `translateX(-${index * step}px)`;

    if (index === data.length) {
      setTimeout(() => {
        track.style.transition = "none";
        track.style.transform = "translateX(0)";
        setIndex(0);
      }, 600);
    }
  }, [index]);

  return (
    <>
      <style>{`
        .wol-wrap {
          max-width: 1200px;
          margin: auto;
          padding: 60px 20px;
          font-family: Inter, sans-serif;
          text-align: center;
        }

        .wol-title {
          font-size: 2.2rem;
          font-weight: 800;
          color: #0f172a;
        }

        .wol-subtitle {
          margin-top: 10px;
          color: #6b7280;
        }

        .wol-slider {
          overflow: hidden;
          margin-top: 50px;
        }

        .wol-track {
          display: flex;
          gap: 24px;
        }

        .wol-card {
          flex: 0 0 calc(25% - 18px);
          
          border-radius: 10px;
          border: 1px solid #7564e6;
          padding: 28px;
          text-align: left;
         
        }

        .wol-user {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wol-user img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }

        .wol-user h4 {
          margin: 0;
          font-size: 1rem;
          font-weight: 700;
        }

        .wol-user span {
          font-size: 0.85rem;
          color: #6b7280;
        }

        .wol-text {
          margin: 18px 0;
          font-size: 0.95rem;
          color: #374151;
          line-height: 1.6;
        }

        .wol-stars {
          color: #f97316;
          font-size: 1.1rem;
        }

        /* TABLET */
        @media (max-width: 1024px) {
          .wol-card {
            flex: 0 0 calc(50% - 12px);
          }
            .wol-wrap {
          width: 80vw;
          margin: auto;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .wol-card {
            flex: 0 0 100%;
            width: 80vw;
          }
            .wol-wrap {
          width: 80vw;
          margin: auto;
        
        }
        }
      `}</style>

      <section className="wol-wrap">
        <h2 className="wol-title">Wall of Love</h2>
        <p className="wol-subtitle">
          People love RapidHR! Here is what our users say.
        </p>

        <div className="wol-slider">
          <div className="wol-track" ref={trackRef}>
            {items.map((item, i) => (
              <div className="wol-card" key={i}>
                <div className="wol-user">
                  <img src={item.image} alt={item.name} />
                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.role}</span>
                  </div>
                </div>
                <p className="wol-text">{item.text}</p>
                <div className="wol-stars">★★★★★</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WallOfLove;
